import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem,
} from "@mui/material";

export default function EditUserForm({ editDialog, setEditDialog, editUserForm }) {
  return (
    <Dialog
      open={editDialog.open}
      onClose={() => {
        setEditDialog({ open: false, user: null });
        editUserForm.resetForm();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Edit User Information</DialogTitle>
      <form onSubmit={editUserForm.handleSubmit}>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={editUserForm.values.firstName}
                onChange={editUserForm.handleChange}
                onBlur={editUserForm.handleBlur}
                error={
                  editUserForm.touched.firstName &&
                  Boolean(editUserForm.errors.firstName)
                }
                helperText={
                  editUserForm.touched.firstName &&
                  editUserForm.errors.firstName
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={editUserForm.values.lastName}
                onChange={editUserForm.handleChange}
                onBlur={editUserForm.handleBlur}
                error={
                  editUserForm.touched.lastName &&
                  Boolean(editUserForm.errors.lastName)
                }
                helperText={
                  editUserForm.touched.lastName && editUserForm.errors.lastName
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Username"
                name="username"
                value={editUserForm.values.username}
                disabled
                sx={{
                  "& .Mui-disabled": {
                    WebkitTextFillColor: "rgba(0, 0, 0, 0.6)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={editUserForm.values.email}
                onChange={editUserForm.handleChange}
                onBlur={editUserForm.handleBlur}
                error={
                  editUserForm.touched.email &&
                  Boolean(editUserForm.errors.email)
                }
                helperText={
                  editUserForm.touched.email && editUserForm.errors.email
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Class Code"
                name="classCode"
                value={editUserForm.values.classCode}
                onChange={editUserForm.handleChange}
                onBlur={editUserForm.handleBlur}
                error={
                  editUserForm.touched.classCode &&
                  Boolean(editUserForm.errors.classCode)
                }
                helperText={
                  (editUserForm.touched.classCode &&
                    editUserForm.errors.classCode) ||
                  "Leave empty to remove the student from any class. New class codes will be auto-created."
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                label="Role"
                name="role"
                value={editUserForm.values.role}
                onChange={editUserForm.handleChange}
                onBlur={editUserForm.handleBlur}
                error={
                  editUserForm.touched.role && Boolean(editUserForm.errors.role)
                }
                helperText={
                  editUserForm.touched.role && editUserForm.errors.role
                }
              >
                <MenuItem value="student">Student</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={() => {
              setEditDialog({ open: false, user: null });
              editUserForm.resetForm();
            }}
            variant="outlined"
            color="inherit"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              py: 1,
              borderColor: "grey.300",
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              py: 1,
              boxShadow: 2,
              "&:hover": {
                boxShadow: 4,
              },
            }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
